import { createSlice } from "@reduxjs/toolkit";

export const collectionSlice = createSlice({
    name: 'collections',
    initialState: {
        value: []
    },
    reducers: {
        addCollection: (state, action) => {
           state.value.unshift(action.payload);
            //state.value.push( action.payload );
        },
        addMany: (state, action) => {
            state.value = [ ...state.value, ...action.payload ];
        },
        setCollections: (state, action) => {
            state.value = action.payload;
        }
    }
});

export const { addCollection, addMany, setCollections } = collectionSlice.actions;

export default collectionSlice.reducer;